export enum ContactSubtype {
    Employee = 'Employee',
    Company = 'Company',
    SelfEmployee = 'Self Employee',
    CommercialClient = 'Commercial Client',
    DomesticClient = 'Domestic Client',
  }